import LocalizationConstructor from '@bumble/localization';
import { IncomingMessage } from 'http';
import acceptLanguageParser from 'accept-language-parser';
import { ParsedUrlQuery } from 'querystring';
import supportedLanguageIds, { SupportedLanguage } from 'lib/lexemes/supported-languages';
// import { AppError } from './app-error';
import { SupportedCountries } from 'lib/supported-countries';

const Localization = new LocalizationConstructor();

export function getLocale(
    req?: IncomingMessage,
    params?: ParsedUrlQuery,
    country?: SupportedCountries | string | number | null | undefined
) {
    // Priority 1. Read language from params if present
    if (params && params.lang) {
        const lang = getLocaleFromParams(params);

        if (lang) {
            return lang;
        }
        // We have a `lang` in params, but it's not valid, we must throw not-found error
        else {
            /**
             * for now to avoid confuses for users
             */
            // return 'en';
            // throw new AppError({
            //     statusCode: 404,
            //     message: `Unknown language code or page - ${params.lang}`,
            // });
        }
    }

    if (country) {
        const langInCountry = {
            [SupportedCountries.UNKNOWN]: 'en',
            [SupportedCountries.UNITED_KINGDOM]: 'en',
            [SupportedCountries.GERMANY]: 'de',
            [SupportedCountries.BRAZIL]: 'pt',
            [SupportedCountries.SPAIN]: 'es',
            [SupportedCountries.RUSSIA]: 'ru',
            [SupportedCountries.FRANCE]: 'fr',
        };

        if (country && country in langInCountry) {
            // @ts-ignore
            return langInCountry[parseInt(country, 10)];
        }
    }

    if (!req) {
        return 'en';
    }

    // Priority 2. Read the accept language header
    const acceptLanguage = req.headers['accept-language'];
    if (acceptLanguage) {
        const pickedLocale = acceptLanguageParser.pick<SupportedLanguage>(
            supportedLanguageIds as unknown as SupportedLanguage[],
            acceptLanguage,
            {
                loose: true,
            }
        );

        if (pickedLocale && supportedLanguageIds.includes(pickedLocale)) {
            return pickedLocale;
        }
    }

    // fall back to English
    return 'en';
}

export function getLocaleFromParams(params?: ParsedUrlQuery) {
    const paramLang = String(params?.lang) as SupportedLanguage;
    return supportedLanguageIds.includes(paramLang) ? paramLang : null;
}

export default Localization;
